module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/user-settings/user-settings.component.scss
// module id = ./src/app/components/user-settings/user-settings.component.scss
// module chunks = main